import DropdownAdm from "../../../../global/component/Genericos/DropdownAdm/DropdowAdm";
import { TopNotis } from "./localStyle";

const TopNoti = ({user, data, filterDataDropDown, localForm, setLocalForm}) => {
   
   
    const messageOne = `Tiene ${data?.length} notificaciones pendientes`;  

    return (
        <TopNotis>
                    <div className="textos">
                        <span className="color1">
                            Hola {user},
                            <span className="color2">
                                {
                                    data?.length > 0 ?
                                    messageOne
                                    :

                                    " no tienes notificaciones."
                                }
                            </span>
                        </span>
                    </div>
        </TopNotis>
    )
}; 

export default TopNoti;